/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.5.3 public/bush.glb -o src/models/plants/Bush.jsx --transform --draco 
Files: public/bush.glb [4.82MB] > /Users/radek/Documents/GIthub/CoffeeCoded/coffeecoded/src/models/plants/assets/plants/bush-transformed.glb [235.24KB] (95%)
*/

import React from 'react'
import { useGLTF } from '@react-three/drei'
import modelUrl from '../../assets/plants/bush-transformed.glb'

export function Model(props) {
  const { nodes, materials } = useGLTF(modelUrl)
  return (
    <group {...props} dispose={null}>
      <mesh geometry={nodes.Plant_01.geometry} material={materials.Vegetation} rotation={[Math.PI / 2, 0, -0.649]} scale={0.01} />
    </group>
  )
}

useGLTF.preload(modelUrl)
